import { useMutation } from "react-query";
import { editHomeCompany } from "actions/Utilities/HomeCompany";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  editStateHomeCompany,
  homeCompanyReFetching,
} from "../atoms/atoms";
import { IHomeCompany } from "../types";
import { toast } from "components/toastNotification";

export default function useEditHomeCompany () {
  
  const setActionEditState = useSetRecoilState(editStateHomeCompany);
  const [isReFetching, setIsReFetching] = useRecoilState(
    homeCompanyReFetching
  );

  const { mutate } = useMutation(
    (newData: IHomeCompany) => 
      editHomeCompany(newData),
    {
      onSuccess: (res) => {

        if (typeof res == "object") {
          toast.fire(
            "Updating Home Company failed",
            `${res.Message}`,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Home Company Updated Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Home Company Updated Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Updating Home Company failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Updating Home Company failed ",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Updating Home Company failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire(
                "Updating Home Company failed",
                `${res}`,
                "error"
              );
          }
        }
        setActionEditState(false);
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire(
          "Update Home Company failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );
  return mutate;
};
